import { ValueOrFn } from "./storeTypes";

export const isCallable = <T>(
  maybeFn: ValueOrFn<T>
): maybeFn is (previousValue: T) => T => typeof maybeFn === "function";
